import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppPermissions } from '@my-aon/auth';
import { EMPTY, Observable, tap } from 'rxjs';
import { DialogContactUsComponent } from '../../components/dialog-contact-us/dialog-contact-us.component';
import { hasValue } from '@my-aon/utils';
import { DialogService } from './dialogService';
import { FileViewModel } from '../models';
import { DialogFilesListComponent, DialogFilesListData } from '../../components/dialog-files-list/dialog-files-list.component';

@Injectable({
    providedIn: 'root',
})
export class CommonDialogsService extends DialogService {

    private _contactUsRef: MatDialogRef<any> | null = null;
    openContactUsDialog(): Observable<void> {
        if (
            hasValue(this._contactUsRef) ||
            !this.auth.hasAnyPermission(
                AppPermissions.GENERAL_CONTACT_US_SEND_REQUEST
            )
        )
            return EMPTY;

        this._contactUsRef = this.dialog.open(DialogContactUsComponent, {

            disableClose: true
        });

        return this._contactUsRef.afterClosed().pipe(
            tap(() => {
                this._contactUsRef = null;
            })
        );
    }

    private _fileListRef: MatDialogRef<any> | null = null;
    openFileListDialog(parameters?: Partial<DialogFilesListData>): Observable<FileViewModel[]> {
        if (
            hasValue(this._fileListRef) ||
            !this.auth.hasAnyPermission(AppPermissions.GENERAL_CONTACT_US_SEND_REQUEST)
        )
            return EMPTY;

        this._fileListRef = this.dialog.open(DialogFilesListComponent, {
            data: parameters,
            position: undefined,
            minWidth: 500,
            minHeight: 250,
            width: '50vw',
            height: '50vh',
            hasBackdrop: true,
            disableClose: true
        });

        return this._fileListRef.afterClosed().pipe(
            tap(() => {
                this._fileListRef = null;
            })
        );
    }
}
